import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoungeQuoteResult } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-gmt-lounge-fare-rules-modal',
  templateUrl: './gmt-lounge-fare-rules-modal.html',
  styleUrls: ['./gmt-lounge-fare-rules-modal.scss'],
  standalone: false
})
export class GmtLoungeModalFareRulesComponent implements OnInit {
  lounge: LoungeQuoteResult = null;
  title = '';
  index = 0;
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}
}

LightningModalTypes.GmtLoungeModalFareRulesComponent.component = GmtLoungeModalFareRulesComponent;
